import { render, staticRenderFns } from "./ListTreatment.vue?vue&type=template&id=5c9ebf45&scoped=true"
import script from "./ListTreatment.vue?vue&type=script&lang=js"
export * from "./ListTreatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9ebf45",
  null
  
)

export default component.exports